import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetCompanyByIdQuery } from "../slices/companySlice";
import { Button, Card, Col, ListGroup, Row } from "react-bootstrap";
import EditCompanyDetailsScreen from "./EditCompanyDetailsScreen";
import { setCredentials } from "../slices/authSlice";

const ViewCompanyDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [isEditable, setIsEditable] = useState(false);

  const {
    data: companyDetails,
    isLoading,
    error,
    refetch,
  } = useGetCompanyByIdQuery({
    token: userInfo?.token,
  });

  const dispatch = useDispatch();
  useEffect(() => {
    if (!isEditable) {
      refetch();
      if (companyDetails && !isLoading) {
        dispatch(setCredentials({ ...userInfo, companyId: companyDetails }));
      }
    }
  }, [isEditable, refetch, companyDetails]);

  const handleEdit = () => {
    setIsEditable(true);
  };

  return (
    <>
      {isEditable ? (
        <EditCompanyDetailsScreen
          companyInfo={companyDetails}
          editable={setIsEditable}
        />
      ) : (
        <>
          <Row className="mb-3">
            <Col>
              <Button variant="primary" onClick={() => navigate("/")}>
                Back
              </Button>
            </Col>
          </Row>

          <h6> Company Details</h6>

          <Row>
            <Col md={5}>
              <Card>
                <ListGroup>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Company Name:</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?.companyName}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Company Id:</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?._id}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Category:</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?.companyCategory}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong> Address:</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?.companyAddress}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>City</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?.companyCity}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Pincode:</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?.companyPincode}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>State</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?.companyState}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Contact:</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?.companyContact}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Seperate PltformFee:</strong>
                      </Col>
                      <Col>
                        <strong>
                          {companyDetails?.separatePlaformFee ? "Yes" : "No"}
                        </strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  {companyDetails?.separatePlaformFee && (
                    <ListGroup.Item>
                      <Row>
                        <Col>
                          <strong>PlatformFee:</strong>
                        </Col>
                        <Col>
                          <strong>{companyDetails?.platformFee}%</strong>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  )}

                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Operation Status</strong>:
                      </Col>
                      <Col>
                        <strong>
                          {companyDetails?.operationStatus ? "Yes" : "No"}
                        </strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Added By:</strong>
                      </Col>
                      <Col>
                        <strong>{companyDetails?.addedBy}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>
          </Row>

          <Row className="justify-content-center align-items-center">
            <Col xs="auto">
              <Button onClick={handleEdit}>Edit</Button>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default ViewCompanyDetailsScreen;
